import React from "react";
import { useSelector } from "react-redux";
import useMovieTrailer from "../hooks/useMovieTrailer";

const VideoBackgroung = ({movieId}) => {
  const trailervd = useSelector((store) => store.movies?.trailerVideo)
 
  useMovieTrailer(movieId);

  return (
    <div className="w-full">
      <iframe className="w-full aspect-video"
        
        src={"https://www.youtube.com/embed/" + trailervd?.key +"?&autoplay=1&mute=1&controls=0"}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullcreen
      ></iframe>
    </div>
  ); 
};

export default VideoBackgroung;
